import { useEffect } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { getActiveOffer } from 'features/provider/services/providerOrderApi';
import { queryKeys } from 'core/query/queryKeys';
import { POLL_OFFER_MS } from 'core/realtime/realtimeConfig';

/** Poll-only active dispatch offer while online (no global SSE hub). */
export function useActiveOfferUpdates(isOnline: boolean) {
  const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: queryKeys.orders.activeOffer,
    queryFn: getActiveOffer,
    enabled: isOnline,
    refetchInterval: isOnline ? POLL_OFFER_MS : false,
  });

  useEffect(() => {
    if (!isOnline) {
      queryClient.setQueryData(queryKeys.orders.activeOffer, null);
    }
  }, [isOnline, queryClient]);

  return query;
}
